import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent, ref, toRefs } from "@vue/composition-api";
import { useVuelidate } from "@Shared/@Composables/validations/useVuelidate";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import PersonalDetailsStep from "./personal-details-step.vue";
import LoginStep from "./login-step.vue";
import { useAccountStoreActions, useAccountStoreMutations } from "@Client/@Modules/main/store/account/account-helpers";
import { isEmpty, parseInt } from "lodash";
import * as AccountActions from "@Client/@Modules/main/store/account/account-actions";
import * as AccountMutations from "@Client/@Modules/main/store/account/account-mutations";
import Amplitude from "@Shared/@Utils/amplitude";
import { useRouter } from "@Shared/@Composables/router/useRouter";
export default defineComponent({
  name: "SignUp",
  components: {
    SimpleButton,
    PersonalDetailsStep,
    LoginStep
  },
  props: {
    redirectPath: {
      type: String,
      default: "/"
    },
    referrerId: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const {
      v$
    } = useVuelidate();
    const isBrokerInvitation = ref(false);
    const currentStep = ref("PersonalDetailsStep");
    const currentSubdomain = ref(window.location.pathname.replace("/", ""));
    const email = ref("");
    const loading = ref(false);
    const loadingStatus = ref(true);
    const {
      router
    } = useRouter();
    const {
      redirectPath,
      referrerId
    } = toRefs(props);
    const loadingDetails = ref(false);
    const {
      LOGIN,
      INIT_SESSION,
      CREATE_ACCOUNT
    } = useAccountStoreActions([AccountActions.LOGIN, AccountActions.INIT_SESSION, AccountActions.CREATE_ACCOUNT]);
    const {
      SET_IS_NEW_ACCOUNT_CREATED_EMBEDDED_LINK
    } = useAccountStoreMutations([AccountMutations.SET_IS_NEW_ACCOUNT_CREATED_EMBEDDED_LINK]);
    const showLoginPage = loginEmail => {
      email.value = loginEmail;
      currentStep.value = "LoginStep";
    };
    const login = async ({
      email: loginEmail,
      password
    }) => {
      loading.value = true;
      const sessionResult = await LOGIN({
        email: loginEmail,
        password,
        subdomain: currentSubdomain.value
      });
      loadingStatus.value = !isEmpty(sessionResult);
      loading.value = false;
      if (!sessionResult) {
        loading.value = false;
        loadingStatus.value = false;
        return;
      }
      await INIT_SESSION(sessionResult);
      Amplitude.startSession(sessionResult);
      return router.push({
        name: "subdomain-interstitial",
        query: {
          force: sessionResult.showInterstitial,
          startUrl: redirectPath.value
        }
      });
    };
    const createAccount = async ({
      formData
    }) => {
      loading.value = true;
      const result = await CREATE_ACCOUNT({
        accountDetails: _objectSpread(_objectSpread({}, formData), {}, {
          referrerId: parseInt(referrerId.value) || referrerId.value
        })
      });
      if (!result) {
        loadingStatus.value = false;
        loading.value = false;
        return;
      }
      if (!isBrokerInvitation.value) {
        SET_IS_NEW_ACCOUNT_CREATED_EMBEDDED_LINK(true);
      }
      await login({
        email: formData.email,
        password: formData.password
      });
    };
    return {
      v$,
      currentStep,
      email,
      loading,
      loadingStatus,
      isBrokerInvitation,
      showLoginPage,
      login,
      createAccount,
      loadingDetails
    };
  }
});